<template>
  <div class="container">
    <b-modal
      no-close-on-backdrop
      hide-footer
      id="linkFamily"
      title="VINCULAR FAMILIARES"
      :size="isNotCustomerHasResident.length == 0 ? 'md' : 'xl'"
    >
      <b-overlay :show="loadingIsNotCustomerHasResident" opacity="0.99">
        <div
          class="v-clean p-5 text-center col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
          v-if="isNotCustomerHasResident.length == 0"
        >
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>

        <div v-if="isNotCustomerHasResident.length > 0">
          <div class="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-12 p-0">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              placeholder="PESQUISAR FAMILIARES"
              outlined
              dense
            ></v-text-field>
          </div>

          <v-data-table
            dense
            :headers="[
              { text: 'NOME', value: 'customer_name' },
              { text: 'GRAU DE PARENTESCO', value: 'type_of_customer_name' },
              { text: '', value: 'action' },
            ]"
            :items="isNotCustomerHasResident"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 25, 100],
              'items-per-page-text': 'Mostrar',
            }"
          >
            <template v-slot:[`item.action`]="{ item }">
              <v-btn
                small
                class="btn-edit"
                @click="createCustomerHasResident(item)"
              >
                <i class="fas fa-pencil-alt mr-2 text-twenty"></i> VINCULAR
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </b-overlay>
    </b-modal>

    <b-overlay :show="loadingCustomerHasResident" opacity="0.99">
      <div class="row mb-3">
        <div
          class="col-xl-6 col-lg-6 col-md-6 col-sm-7 col-12 pb-0 d-flex justify-content-start align-items-center"
        >
          <h6 class="title-pages mb-0">FAMILIARES VINCULADOS</h6>
        </div>

        <div
          class="col-xl-6 col-lg-6 col-md-6 col-sm-5 col-12 d-flex justify-content-end align-items-center"
        >
          <v-btn class="btn-add" @click="$bvModal.show('linkFamily')">
            <i class="fas fa-plus mr-2 text-twenty"></i> VINCULAR
          </v-btn>
        </div>
      </div>

      <!-- Informação importante sobre responsável pelo pagamento -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="payment-info-card">
            <div class="payment-info-header">
              <i class="fas fa-info-circle mr-2"></i>
              <span class="payment-info-title">Informação Importante</span>
            </div>
            <div class="payment-info-body">
              <p class="mb-0">
                <strong>Responsável pelo Pagamento:</strong> Apenas um familiar
                pode ser definido como responsável pelo pagamento. O boleto será
                emitido com os dados do familiar selecionado.
              </p>
            </div>
          </div>
        </div>
      </div>

      <ErrorsMessages :errors="errors" />

      <div
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center v-clean p-5"
        v-if="isCustomerHasResident.length == 0"
      >
        <h6 class="upper-text worksansr">Nenhum familiar vinculado!</h6>
      </div>

      <div class="row">
        <div
          class="col-12 mb-3"
          v-for="(item, key) in isCustomerHasResident"
          :key="key"
        >
          <div class="family-card">
            <div class="family-card-header">
              <div class="family-info">
                <h6 class="family-name">{{ item.customer_name }}</h6>
                <div class="family-relationship">
                  <span class="relationship-label">Grau de parentesco:</span>
                  <span class="relationship-value">{{
                    item.type_of_customer_name
                  }}</span>
                </div>
              </div>

              <div class="family-actions">
                <ConfirmationDialog
                  headerClass="modal-header-red"
                  message-title="REMOVER?"
                  message-body="Deseja realmente remover vínculo do residente com familiar?"
                  open-class="btn-delete"
                  open-left-icon="fa-times"
                  openText="EXCLUIR"
                  @yes="deleteCustomerHasResident(item.customer_id)"
                />
              </div>
            </div>

            <div class="family-card-body">
              <div class="responsibility-section">
                <div class="responsibility-item">
                  <label
                    :for="`responsible_for_payment_${item.customer_id}`"
                    class="responsibility-label"
                  >
                    <input
                      :id="`responsible_for_payment_${item.customer_id}`"
                      type="checkbox"
                      :checked="item.responsible_for_payment"
                      :ref="`responsible_for_payment_${item.customer_id}`"
                      @click="handleChangeResponsibleForPayment(item)"
                      class="responsibility-checkbox"
                    />
                    <span class="responsibility-text">
                      <i class="fas fa-money-bill-wave mr-2"></i>
                      Responsável pelo pagamento
                    </span>
                  </label>
                  <span
                    v-if="item.responsible_for_payment"
                    class="badge-responsible badge-responsible-payment"
                  >
                    Boleto emitido para este familiar
                  </span>
                </div>

                <div class="responsibility-item">
                  <label
                    :for="`responsible_for_contract_${item.customer_id}`"
                    class="responsibility-label"
                  >
                    <input
                      :id="`responsible_for_contract_${item.customer_id}`"
                      type="checkbox"
                      :checked="item.responsible_for_contract"
                      :ref="`responsible_for_contract_${item.customer_id}`"
                      @click="handleChangeResponsibleForContract(item)"
                      class="responsibility-checkbox"
                    />
                    <span class="responsibility-text">
                      <i class="fas fa-file-contract mr-2"></i>
                      Responsável pelo contrato
                    </span>
                  </label>
                  <span
                    v-if="item.responsible_for_contract"
                    class="badge-responsible badge-responsible-contract"
                  >
                    Familiar pode sair no contrato cadastrado
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import api from "../../services/api";
import toast from "../../lib/ToastNotification";
import ErrorsMessages from "../../templates/Components/ErrorsMessages";
import ConfirmationDialog from "../../templates/Components/ConfirmationDialog";

export default {
  name: "CustomerHasResident",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
  },

  props: {
    rest_home_id: [String, Number],
    resident_id: [String, Number],
    user_id: [String, Number],
  },

  data() {
    return {
      search: "",
      customers: [],
      loadingIsNotCustomerHasResident: true,
      loadingCustomerHasResident: false,
      isCustomerHasResident: [],
      isNotCustomerHasResident: [],
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    async retrieve() {
      if (this.errors.length == 0) await this.getCustomers();
      if (this.errors.length == 0) await this.getCustomerHasResident();
      if (this.errors.length == 0) await this.getNotCustomerHasResident();
    },

    async getCustomers() {
      try {
        const response = await api.get("/rest-home/customers");
        const { error, errors, customers } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.customers = customers;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getNotCustomerHasResident() {
      try {
        this.loadingIsNotCustomerHasResident = true;
        const { rest_home_id, resident_id } = this;

        const response = await api.get(
          "/rest-home/customer/unrelated-customers",
          {
            params: { rest_home_id, resident_id },
          }
        );

        const { error, errors, customers } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.isNotCustomerHasResident = customers;
        }

        this.loadingIsNotCustomerHasResident = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getCustomerHasResident() {
      try {
        this.loadingCustomerHasResident = true;
        const { resident_id } = this;

        const response = await api.get("/rest-home/customer/by-resident", {
          params: { resident_id },
        });

        const { error, errors, customerHasResident } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.isCustomerHasResident = customerHasResident;
        }

        this.loadingCustomerHasResident = false;
      } catch (error) {
        console.log(error);
      }
    },

    async createCustomerHasResident({ customer_id }) {
      try {
        const { user_id, resident_id } = this;
        let params = { user_id, resident_id, customer_id };

        const response = await api.post(
          "/rest-home/customer/bind-resident",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.getCustomerHasResident();
          this.getNotCustomerHasResident();
          this.$bvModal.hide("linkFamily");
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async deleteCustomerHasResident(customer_id) {
      try {
        const { user_id, resident_id } = this;
        let data = { user_id, customer_id, resident_id };

        const response = await api.delete(
          "/rest-home/customer/unbind-resident",
          {
            data,
          }
        );

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.getCustomerHasResident();
          this.getNotCustomerHasResident();
        } else {
          toast(message, "error");
        }
      } catch (error) {
        console.log(error);
      }
    },

    async handleChangeResponsibleForPayment(item) {
      try {
        const { resident_id } = this;
        const { customer_id } = item;

        var responsible_for_payment =
          this.$refs[`responsible_for_payment_${customer_id}`][0].checked;

        let params = { resident_id, customer_id, responsible_for_payment };

        const response = await api.post(
          "/rest-home/customer/responsible-for-payment/update",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.getCustomerHasResident();
          this.errors = [];
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async handleChangeResponsibleForContract(item) {
      try {
        const { resident_id } = this;
        const { customer_id } = item;

        let responsible_for_contract =
          this.$refs[`responsible_for_contract_${customer_id}`][0].checked;

        let params = { resident_id, customer_id, responsible_for_contract };

        const response = await api.post(
          "/rest-home/customer/responsible-for-contract/update",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.getCustomerHasResident();
          this.errors = [];
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async handleChangeGuarantor(item) {
      try {
        const { resident_id } = this;
        const { customer_id } = item;

        var guarantor = this.$refs[`guarantor_${customer_id}`][0].checked;

        let params = { resident_id, customer_id, guarantor };

        const response = await api.post(
          "/rest-home/customer/guarantor/update",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.getCustomerHasResident();
          this.errors = [];
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
/* Card de Informação de Pagamento */
.payment-info-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.2);
}

.payment-info-header {
  background: rgba(255, 255, 255, 0.15);
  padding: 12px 20px;
  display: flex;
  align-items: center;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
}

.payment-info-header i {
  font-size: 18px;
}

.payment-info-title {
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.payment-info-body {
  padding: 16px 20px;
  color: #fff;
  font-size: 14px;
  line-height: 1.6;
}

.payment-info-body p {
  margin: 0;
}

.payment-info-body strong {
  font-weight: 600;
}

/* Card de Familiar */
.family-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid #e8e8e8;
}

.family-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.family-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-bottom: 2px solid #e8e8e8;
}

.family-info {
  flex: 1;
}

.family-name {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  text-transform: uppercase;
}

.family-relationship {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.relationship-label {
  color: #7f8c8d;
  font-weight: 500;
}

.relationship-value {
  color: #2c3e50;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.7);
  padding: 4px 12px;
  border-radius: 20px;
}

.family-actions {
  margin-left: 20px;
}

.family-card-body {
  padding: 20px;
}

/* Seção de Responsabilidades */
.responsibility-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.responsibility-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px solid transparent;
  transition: all 0.3s ease;
}

.responsibility-item:hover {
  background: #e9ecef;
  border-color: #dee2e6;
}

.responsibility-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0;
  user-select: none;
  flex: 1;
}

.responsibility-checkbox {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin: 0;
  accent-color: #667eea;
}

.responsibility-text {
  margin-left: 12px;
  font-size: 15px;
  font-weight: 500;
  color: #2c3e50;
  display: flex;
  align-items: center;
}

.responsibility-text i {
  color: #667eea;
  font-size: 16px;
}

.badge-responsible {
  color: #fff;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(17, 153, 142, 0.3);
}

.badge-responsible-payment {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
}

.badge-responsible-contract {
  background: linear-gradient(135deg, #114199 0%, #3872ef 100%);
}

/* Responsividade */
@media (max-width: 768px) {
  .family-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .family-actions {
    margin-left: 0;
    width: 100%;
  }

  .responsibility-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .badge-responsible {
    align-self: flex-start;
  }

  .payment-info-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

/* Acessibilidade - Foco no teclado */
.responsibility-checkbox:focus {
  outline: 3px solid #667eea;
  outline-offset: 2px;
}

.responsibility-label:focus-within {
  background: #e9ecef;
}
</style>